

// Material Dashboard 2 React layouts
import LoginScreen from "./layouts/authentication/login";

//icons
import DashboardIcons from "./assets/icons/Dashbord.png";
import addReservationIcons from "./assets/icons/addReservation_icon.png"
import TarifChartIcons from "./assets/icons/Tariff Chart_icon.png"
import MaintenanceIcons from "./assets/icons/Maintenance List Icons.png"
import RoomBlockLIcon from "./assets/icons/Room Block.png"
import AttendanceIcon from "./assets/icons/user.png"
import ReservationListIcons from "./assets/icons/staff.png"
import DashBoardPanelIcon from "./assets/icons/dashboard-panel.png"
import AmountIcon from "./assets/icons/indian-rupee-sign.png"


//screens
import Employee from "./layouts/Employee";
import AddvanceReqestList from "./layouts/AdvanceRequestList";
import HRMSDashboard from "./layouts/Dashboard";
import AddEmployee from "./layouts/Employee/AddEmployee";
import Attendance from "./layouts/Attendance";
import AttendanceSummary from "./layouts/Attendance/summary";
import CreateAdvanceRequest from "./layouts/AdvanceRequestList/CreateAdvanceRequest";
import Device from "./layouts/Device";
import attendanceDeviceIcon from "../src/assets/image/attendance-device.png"
import MarkAttendance from "./layouts/MarkAttendance";
import AdvanceReport from "./layouts/AdvanceRequestList/Advance-reprot";
import Attendance_Alteration from "./layouts/Attendance/Attendance_Alteration";
export const routes = [

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <img src={DashBoardPanelIcon} width="22px" />,
    route: "/dashboard",
    component: HRMSDashboard,
  },
  {
    type: "collapse",
    name: "Employee List",
    key: "employee",
    icon: <img src={ReservationListIcons} width="22px" />,
    route: "/employee/list",
    component: Employee,
  },
  {
    type: "hidden",
    name: "Add Employee",
    key: "employee",
    icon: <img src={ReservationListIcons} width="22px" />,
    route: "/employee/add",
    component: AddEmployee,
  },

  // {
  //   type: "hidden",
  //   name: "Employee Details",
  //   key: "Employee Details",
  //   icon: <img src={ReservationListIcons} width="24px" />,
  //   route: "/Employee/details",
  //   component: AddEmployee,
  // },
{
  type: "collapse",
  name: "Advance Request",
  key: "advance-request-main",
  icon: <img src={AmountIcon} width="22px" />,
  // route: "/advance-request", // parent route (optional if only subRoutes are used)
  subRoutes: [
    {
      type: "collapse",
      name: "Advance Request List",
      key: "advance-request-list",
      icon: <img src={AmountIcon} width="22px" />,
      route: "/advance-request/list",
      component: AddvanceReqestList,
    },
   
    {
      type: "hidden",
      name: "Create Request",
      key: "advance-request-create",
      icon: <img src={ReservationListIcons} width="22px" />,
      route: "/advance-requests/create",
      component: CreateAdvanceRequest,
    },
    {
      type: "collapse",
      name: "Advance Report",
      key: "advance-report",
      icon: <img src={AmountIcon} width="22px" />,
      route: "/advance/report",
      component: AdvanceReport,
    },
  ],
}
,
  {
    type: "collapse", // or "title" based on your layout behavior
    name: "Attendance Tracker",
    key: "Attendance",
    icon: <img src={AttendanceIcon} width="24px" />,
    // route: "/Attendance", // parent route (won’t be used if only subroutes are used)
    subRoutes: [
     
      {
        type: "collapse",
        name: "Daily Submission",
        key: "AttendanceMain",
        icon: <img src={AttendanceIcon} width="24px" />,
        route: "/Attendance/list",
        component: Attendance,
      },
      {
        type: "collapse",
        name: "Attendance Summary",
        key: "AttendanceSummary",
        icon: <img src={ReservationListIcons} width="24px" />,
        route: "/Attendance/summary",
        component: AttendanceSummary,
      },
       {
        type: "collapse",
        name: "Attendance Alteration",
        key: "AttendanceAlteration",
        icon: <img src={ReservationListIcons} width="24px" />,
        route: "/Attendance/Alteration",
        component: Attendance_Alteration,
      },
    ]
  }
  ,
  {
    type: "collapse",
    name: "Device List",
    key: "device",
    icon: <img src={attendanceDeviceIcon} width="22px" />,
    route: "/device/list",
    component: Device,
  },

];

export const un_auth_routes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    // icon: <DashboardIcon />,
    route: "/authentication/sign-in",
    component: LoginScreen,
  },
];

export default routes;
